var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNopCoQuanThue597B198B1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4354",
    "data-name": "Ellipse 4354",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#f5f8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.909,
    y1: 1,
    x2: 0.294,
    y2: -0.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7edfe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_75924",
    x: -0.874,
    y: 39.82,
    width: 58.794,
    height: 68.15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#66afff",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_34521",
    x: 43.002,
    y: 29.121,
    width: 35.471,
    height: 35.471,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#66afff",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.074,
    y1: 0.282,
    x2: 0.918,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007aff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_76016",
    x: 54.081,
    y: 57.308,
    width: 24.878,
    height: 15.577,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6bd2ff",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_76017",
    x: 61.305,
    y: 52.799,
    width: 14.008,
    height: 12.935,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#6bd2ff",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NopCoQuanThue",
    transform: "translate(-748.5 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53269",
    "data-name": "Group 53269",
    transform: "translate(11561.5 5832)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4349",
    "data-name": "Ellipse 4349",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-10813 -5522)",
    fill: "#f5f9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-10813 -5522)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53124",
    "data-name": "Group 53124",
    transform: "translate(14.465 21.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22756",
    "data-name": "Rectangle 22756",
    width: 51.072,
    height: 63.579,
    rx: 4,
    transform: "translate(0 0)",
    fill: "#007aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22757",
    "data-name": "Rectangle 22757",
    d: "M1,0H50.072a1,1,0,0,1,1,1V3.254a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V1A1,1,0,0,1,1,0Z",
    transform: "translate(0 0)",
    fill: "#71b5ff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5152",
    "data-name": "Line 5152",
    y2: 13.107,
    transform: "translate(26.057 4.091)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4352",
    "data-name": "Ellipse 4352",
    cx: 2.085,
    cy: 2.085,
    r: 2.085,
    transform: "translate(23.973 13.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4353",
    "data-name": "Ellipse 4353",
    cx: 2.085,
    cy: 2.085,
    r: 2.085,
    transform: "translate(23.973 1.042)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53125",
    "data-name": "Group 53125",
    transform: "translate(8.126 45.82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.13, -45.82)",
    filter: "url(#Path_75924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75924-2",
    "data-name": "Path 75924",
    d: "M.438,2.668A2.549,2.549,0,0,1,2.986.119H29.67A2.549,2.549,0,0,1,31.5.9l9.012,9.334A2.549,2.549,0,0,1,41.231,12V47.72a2.549,2.549,0,0,1-2.549,2.549H2.986A2.549,2.549,0,0,1,.438,47.72Z",
    transform: "translate(7.69 45.7)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22758",
    "data-name": "Rectangle 22758",
    width: 25.015,
    height: 4.169,
    rx: 2.085,
    transform: "translate(7.296 7.465)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22759",
    "data-name": "Rectangle 22759",
    width: 15.634,
    height: 4.169,
    rx: 2.085,
    transform: "translate(7.296 14.688)",
    fill: "#6bd2ff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22760",
    "data-name": "Rectangle 22760",
    width: 25.015,
    height: 4.169,
    rx: 2.085,
    transform: "translate(7.296 24.31)",
    fill: "#6bd2ff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_34521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34521-2",
    "data-name": "Path 34521",
    d: "M16.471,0,10.588,16.471,8.161,8.688,0,5.882Z",
    transform: "translate(52.5 52.09) rotate(-90)",
    fill: "#6bd2ff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55151",
    "data-name": "Group 55151",
    transform: "translate(802.5 364.114)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4391",
    "data-name": "Ellipse 4391",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(0 -0.114)",
    fill: "#007aff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76014",
    "data-name": "Path 76014",
    d: "M39.317,543.724,32.339,538l-.356,7.512-8.585.715-3.4.715,9.422,4.446Z",
    transform: "translate(-13.919 -527.66)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53214",
    "data-name": "Group 53214",
    transform: "translate(6.081 9.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76015",
    "data-name": "Path 76015",
    d: "M22.5,537H21.431A1.431,1.431,0,0,0,20,538.431v6.439a1.431,1.431,0,0,0,1.431,1.431H22.5Zm1.073,9.3h2.5V537h-2.5Zm3.577-9.3v9.3h2.5V537Zm3.577,0v9.3h.715a1.431,1.431,0,0,0,1.431-1.431v-6.439A1.431,1.431,0,0,0,31.447,537Z",
    transform: "translate(-20 -537)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53215",
    "data-name": "Group 53215",
    transform: "translate(6.081 8.193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -60.08, -62.31)",
    filter: "url(#Path_76016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76016-2",
    "data-name": "Path 76016",
    d: "M20,534.862A2.862,2.862,0,0,1,22.862,532h7.154a2.862,2.862,0,0,1,2.862,2.862v.716H20Z",
    transform: "translate(40.08 -469.69)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53216",
    "data-name": "Group 53216",
    transform: "translate(11.808 4.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22841",
    "data-name": "Rectangle 22841",
    width: 4,
    height: 1,
    rx: 0.5,
    transform: "translate(1.192 -0.109) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53217",
    "data-name": "Group 53217",
    transform: "translate(4.087 17.712)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22842",
    "data-name": "Rectangle 22842",
    width: 17,
    height: 2,
    rx: 1,
    transform: "translate(-0.087 0.174)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53218",
    "data-name": "Group 53218",
    transform: "translate(11.805 3.185)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.8, -57.3)",
    filter: "url(#Path_76017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76017-2",
    "data-name": "Path 76017",
    d: "M38.5,521.935a5.645,5.645,0,0,1-2.142-.426.594.594,0,0,1-.362-.552v-2.365a.586.586,0,0,1,.254-.489.574.574,0,0,1,.539-.063,4.509,4.509,0,0,0,3.421,0,.574.574,0,0,1,.539.063.586.586,0,0,1,.254.489v2.365a.6.6,0,0,1-.362.552A5.645,5.645,0,0,1,38.5,521.935Z",
    transform: "translate(29.8 -460.7)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopCoQuanThue597B198B1);
export default __webpack_public_path__ + "static/media/NopCoQuanThue.597b198b (1).2b78fe1d6001965c7bf3f8367a3d7a06.svg";
export { ForwardRef as ReactComponent };